/**
 * @module store/modules/auth
 * @description 인증 상태 관리 Vuex 모듈
 * 로그인 상태, 사용자 정보(JWT 포함), 사용자명, 바이패스 토큰을 관리합니다.
 */
export default {
  // ============================================================
  // State
  // ============================================================
  state: () => ({
    isLogin: false,
    user: {},
    userName: '',
    bypassToken: 'AasmfOASJDbfoajgPGDKdghBNAspfJAbgOASDfgjasfnSDgjbDSjojsdsjs'
  }),
  // ============================================================
  // Getters
  // ============================================================
  getters: {
    /** @returns {string} 현재 로그인한 사용자의 이름 */
    userName: (state) => state.userName
  },
  // ============================================================
  // Mutations
  // ============================================================
  mutations: {
    /**
     * 로그인 상태를 설정합니다.
     *
     * @param {object} state - Vuex 상태 객체
     * @param {boolean} data - 로그인 여부
     */
    isLogin(state, data) {
      state.isLogin = data
    },
    /**
     * 사용자 인증 정보(JWT 포함 객체)를 설정합니다.
     *
     * @param {object} state - Vuex 상태 객체
     * @param {object} data - 인증 응답 데이터 (authToken 등 포함)
     */
    user(state, data) {
      state.user.id = data
    },
    /**
     * 사용자 이름을 설정합니다.
     *
     * @param {object} state - Vuex 상태 객체
     * @param {string} name - 설정할 사용자 이름
     */
    setUserName(state, name) {
      state.userName = name
    },
    /**
     * 파트너 ID를 사용자 정보에 업데이트합니다.
     *
     * @param {object} state - Vuex 상태 객체
     * @param {number|string} data - 설정할 파트너 ID
     */
    setPartnerId(state, data) {
      state.user.id.partnerId = data
    },
    /**
     * 사용자 역할 코드를 업데이트합니다.
     *
     * @param {object} state - Vuex 상태 객체
     * @param {string} data - 설정할 사용자 역할 코드
     */
    setUserRoleCode(state, data) {
      state.user.id.userRoleCode = data
    }
  },
  // ============================================================
  // Actions
  // ============================================================
  actions: {
    /**
     * 사용자 이름을 커밋합니다.
     *
     * @param {object} context - Vuex 액션 컨텍스트
     * @param {string} name - 설정할 사용자 이름
     */
    setUserName({ commit }, name) {
      commit('setUserName', name)
    }
  }
}
